import * as React from 'react';
import * as Yup from 'yup';
import {inject, observer} from 'mobx-react';
import {Formik, FormikProps} from 'formik';
import FormBase, {FormValues} from './private/RegistrationVerificationFormBase';
import {Auth} from '../../models/authModel';

interface WithInjectedProps {
  auth: Auth;
}

@inject('auth')
@observer
export default class RegistrationVerificationForm extends React.Component<{}, {}> {
  public render() {
    const {
      verificationPassed,
      verificationFailed,
      verifying,
      resendingCode
    } = this._withInjectedProps.auth.registration;

    return (
      <Formik
        initialValues={{code: ''}}
        validationSchema={this._validationSchema}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => (
          <FormBase
            passed={verificationPassed}
            failed={verificationFailed}
            loading={verifying}
            handleCodeResend={this._handleCodeResend}
            resendingCode={resendingCode}
            {...props}
          />
        )}
      />
    );
  }

  private get _validationSchema() {
    return Yup.object().shape({
      code: Yup.string().required('Please enter the code you have received.')
    });
  }

  private _handleSubmit = ({code}: FormValues) => {
    this._withInjectedProps.auth.verifyRegistration(code, 'host');
  };

  private _handleCodeResend = () => {
    this._withInjectedProps.auth.resendVerificationCode();
  };

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}



// WEBPACK FOOTER //
// ./src/containers/RegistrationVerificationForm/RegistrationVerificationForm.tsx